import React, { useLayoutEffect, ReactElement } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';

import MainPage from 'pages/MainPage';
import AboutPage from 'pages/AboutPage';
import AboutPeoplePage from 'pages/AboutPeoplePage';
import AlbumsPage from 'pages/AlbumsPage';
import AlbumDetailsPage from 'pages/AlbumDetailsPage';
import ToursPage from 'pages/ToursPage';
import TourDetailsPage from 'pages/TourDetailsPage';
import ConcertDetailsPage from 'pages/ConcertDetailsPage';
import ConcertsPage from 'pages/ConcertsPage';
import FanDomePage from 'pages/FanDomePage';
import HistoryPage from 'pages/HistoryPage';
import AwardsPage from 'pages/AwardsPage';
import SongDetailsPage from 'pages/SongDetailsPage';
import SongsPage from 'pages/SongsPage';
import PrivacyPolicyPage from 'pages/PrivacyPolicyPage';
import DvdsDetailsPage from 'pages/DvdsDetailsPage';

const RouterWrapper = (props: { children: ReactElement }) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0
    });
  }, [location.pathname]);

  return props.children;
};

const RoutesConfig = () => (
  <BrowserRouter>
    <RouterWrapper>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/about/:peopleId" element={<AboutPeoplePage />} />
        <Route path="/about/awards" element={<AwardsPage />} />
        <Route path="/about/history" element={<HistoryPage />} />
        <Route path="/albums" element={<AlbumsPage />} />
        <Route path="/dvds" element={<AlbumsPage />} />
        <Route path="/albums/:albumId" element={<AlbumDetailsPage />} />
        <Route path="/albums/:albumId/:songId" element={<SongDetailsPage />} />
        <Route path="/dvds/:dvdId" element={<DvdsDetailsPage />} />
        <Route path="/songs" element={<SongsPage />} />
        <Route path="/tours-and-shows" element={<ToursPage />} />
        <Route path="/tours-and-shows/shows" element={<ConcertsPage />} />
        <Route path="/tours-and-shows/shows/:year" element={<ConcertsPage />} />
        <Route path="/tours-and-shows/shows/festivals-shows-special-events" element={<ConcertsPage isConcertsFestivals />} />
        <Route path="/tours-and-shows/shows/festivals-shows-special-events/:year" element={<ConcertsPage isConcertsFestivals />} />
        <Route path="/tours-and-shows/shows/festivals-shows-special-events/:year/:concertId" element={<ConcertDetailsPage />} />
        <Route path="/tours-and-shows/:tourId" element={<TourDetailsPage />} />
        <Route path="/tours-and-shows/:tourId/:concertId" element={<ConcertDetailsPage />} />
        <Route path="/fan-dome" element={<FanDomePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      </Routes>
    </RouterWrapper>
  </BrowserRouter>
);

export default RoutesConfig;
